(function () {
  'use strict';
  /* royme · Regali nelle offerte a pezzi (snippet ry-regali): pastiglia «+ 2 regali» e lista dei regali
     sotto le offerte da N pezzi in su; con quelle offerte i regali entrano da soli nel carrello, una volta sola.
     Possono esserci più liste (es. 2 regali da 2 pezzi, 3 regali da 3 pezzi): ogni offerta prende la lista
     con la soglia più alta che raggiunge. */
  var GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>';

  function each(l, f) { Array.prototype.forEach.call(l || [], f); }
  function euro(c) { return '€' + (Math.max(Number(c) || 0, 0) / 100).toFixed(2).replace('.', ','); }
  function base() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function fromOf(t) { return Number(t.getAttribute('data-from')) || 2; }
  function idsOf(t) { return String(t.getAttribute('data-ids') || '').split(',').map(Number).filter(Boolean); }

  /* La lista giusta per un'offerta da «qty» pezzi: quella con la soglia più alta raggiunta. */
  function tierFor(tpls, qty) {
    var pick = null;
    tpls.forEach(function (t) { if (fromOf(t) <= qty && idsOf(t).length) pick = t; });
    return pick;
  }

  function enhance(root, tpls) {
    var ry = root.__ry;
    if (!ry || ry.__ryGifts || ry.mode !== 'offers' || !ry.offers || !ry.offers.length) return;
    ry.__ryGifts = true;

    ry.offers.forEach(function (o) {
      var qty = Number(o.getAttribute('data-qty')) || 1;
      var tpl = tierFor(tpls, qty);
      if (!tpl || o.querySelector('.ry-gifts')) return;
      o.setAttribute('data-gift-ids', idsOf(tpl).join(','));
      var chipText = tpl.getAttribute('data-chip') || '';
      /* «Risparmi [x]» nella riga finale: valore dei regali + quanto si risparmia con l'offerta (data-saving). */
      var saveText = tpl.getAttribute('data-save') || '';
      var giftValue = Number(tpl.getAttribute('data-value')) || 0;
      var info = o.querySelector('[data-ry-chips]') || o.querySelector('.ry-offer__info');
      if (info && chipText) {
        var chip = document.createElement('span');
        chip.className = 'ry-badge ry-gifts__chip';
        chip.innerHTML = GIFT;
        chip.appendChild(document.createTextNode(chipText));
        info.appendChild(chip);
      }
      var pieces = o.querySelector('.ry-offer__pieces');
      var block = tpl.content.cloneNode(true);
      if (pieces && pieces.parentNode === o) o.insertBefore(block, pieces.nextSibling);
      else o.appendChild(block);
      var tot = saveText ? o.querySelector('[data-ry-gifts-save]') : null;
      if (tot) {
        var x = giftValue + (Number(o.getAttribute('data-saving')) || 0);
        var parts = saveText.split('[x]');
        tot.textContent = parts[0];
        if (parts.length > 1) {
          var st = document.createElement('strong');
          st.textContent = euro(x);
          tot.appendChild(st);
          tot.appendChild(document.createTextNode(parts.slice(1).join('')));
        }
      }
    });

    /* All'aggiunta di un'offerta con regali: prima i regali di quell'offerta che mancano nel carrello
       (a €0, uno per tipo), poi i pezzi con l'aggiunta del tema, che aggiorna anche il carrello a comparsa. */
    var add = ry.add;
    ry.add = function () {
      var self = this, args = arguments;
      if (self.busy || self.__ryGiftWait) return;
      var o = self.currentOffer ? self.currentOffer() : null;
      var ids = o ? String(o.getAttribute('data-gift-ids') || '').split(',').map(Number).filter(Boolean) : [];
      if (!ids.length) return add.apply(self, args);
      self.__ryGiftWait = true;
      [self.atc, self.stickyAtc].forEach(function (b) { if (b) b.classList.add('is-loading'); });
      fetch(base() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var have = {};
          (cart.items || []).forEach(function (it) { have[it.variant_id] = true; });
          return ids.filter(function (id) { return !have[id]; });
        })
        .catch(function () { return ids.slice(); })
        .then(function (missing) {
          if (!missing.length) return;
          /* Nel carrello l'ultimo aggiunto va in alto: si mandano al contrario, così restano nell'ordine della lista. */
          var items = missing.map(function (id) { return { id: id, quantity: 1 }; }).reverse();
          return fetch(base() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: items })
          }).catch(function () {});
        })
        .then(function () {
          self.__ryGiftWait = false;
          [self.atc, self.stickyAtc].forEach(function (b) { if (b) b.classList.remove('is-loading'); });
          add.apply(self, args);
        });
    };
  }

  function run(scope) {
    var tpls = Array.prototype.slice.call(document.querySelectorAll('template[data-ry-gifts]'));
    if (!tpls.length) return;
    tpls.sort(function (a, b) { return fromOf(a) - fromOf(b); });
    var tries = 0;
    (function tick() {
      var pending = false;
      each((scope || document).querySelectorAll('[data-ry-product]'), function (r) {
        if (r.__ry) enhance(r, tpls); else pending = true;
      });
      if (pending && tries++ < 40) setTimeout(tick, 150);
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();
  document.addEventListener('shopify:section:load', function (e) { setTimeout(function () { run(e.target); }, 0); });
})();
